import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { CalendarView } from '../../xn-form/xn-form-interface';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'p-calendar',
  standalone: false,
  templateUrl: './calendar.html',
  styleUrl: './calendar.sass',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Calendar),
      multi: true
    }
  ]
})
export class Calendar implements ControlValueAccessor {
  @Input('dateFormat') dateFormat?: string = '';
  @Input('readonlyInput') readonlyInput?: boolean = false;
  @Input('minDate') minDate?: Date;
  @Input('maxDate') maxDate?: Date;
  @Input('showIcon') showIcon?: boolean = false;
  @Input('placeholder') placeholder?: string = '';
  @Input('appendTo') appendTo?: string = '';
  @Input('styleClass') styleClass?: string = '';

  @Input('view') view?: CalendarView;
  @Input('timeOnly') timeOnly: boolean = false;
  @Input('inline') inline: boolean = false;
  @Input('touchUI') touchUI: boolean = false;
  @Input('showWeek') showWeek?: boolean = false;

  @Input('disabledDates') disabledDates?: Date[];
  @Input('numberOfMonths') numberOfMonths?: number;
  @Input('inputStyleClass') inputStyleClass?: string;
  @Output('onSelect') onSelect = new EventEmitter<any>();
  @Output('onMonthChange') onMonthChange = new EventEmitter<any>();
  value: any;

  _value: any;

  writeValue(value: any): void {
    this._value = value;
  }

  propagateChange = (_: any) => {

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {

  }

  _onValueChange(event: any) {
    this._value = event;
    this.propagateChange(event);
  }

  showOverlay(){

  }
  
  clear(){

  }

  toggle(){

  }
}
